import React, { Component } from "react";
import { Typography, Select, MenuItem, Button, Grid } from "@material-ui/core";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";
import _ from "lodash";
import { getToolboxTalks } from "./actions";
import { connect } from "react-redux";
import ToolboxModal from "./ToolboxModal";
import { noImg } from "vrcore-dashboard/dist/utilities";
class JobPackToolboxTalk extends Component {
    constructor(props) {
        super(props);
        props.getToolboxTalks();

        this.state = {
            profile: props.profile,
            edit: props.edit,
            toolboxModal: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderDropdown = (label, key, opts) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: 50,
                    }}
                >
                    <Typography style={{ width: 200 }} variant="h6">
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ marginLeft: 40, width: "50%" }}
                        value={
                            profile[key]
                                ? profile[key].map((e) => {
                                      return _.get(e, "machine_reg") || null;
                                  })
                                : !profile[key]
                                ? []
                                : profile[key]
                        }
                        multiple={true}
                        onChange={(event) => {
                            let newArray = _.flattenDeep(
                                _.compact(
                                    event.target.value.map((e) => {
                                        return _.compact(
                                            opts.map((f) => {
                                                if (e === f.machine_reg) {
                                                    return f;
                                                } else return false;
                                            })
                                        );
                                    })
                                )
                            );

                            this.props.callback(key, newArray);
                        }}
                    >
                        {opts.map((e) => {
                            return (
                                <MenuItem
                                    key={e.machine_reg}
                                    value={e.machine_reg}
                                >
                                    {e.machine_desc + " - " + e.machine_reg}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return null;
        }
    };
    render() {
        const { profile } = this.props;
        const { edit } = this.state;
        console.log(this.props.toolboxes);
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Assigned Toolbox Talk"
            >
                {edit && (
                    <Button
                        variant="contained"
                        style={{
                            background: "#0188cc",
                            color: "white",
                            marginBottom: 24,
                        }}
                        onClick={() => {
                            this.setState({ toolboxModal: true });
                        }}
                    >
                        Select Toolbox Talks
                    </Button>
                )}
                <Grid container spacing={1}>
                    {profile.toolbox_talks &&
                        profile.toolbox_talks.map((e) => {
                            return (
                                <Grid
                                    item
                                    key={e.uid}
                                    xs={6}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    xl={3}
                                >
                                    <img
                                        src={
                                            e.icon_url !== ""
                                                ? e.icon_url
                                                : noImg
                                        }
                                        alt={e.icon_url}
                                        style={{
                                            position: "relative",
                                            width: "90%",
                                            height: "auto",
                                            margin: "0 auto",
                                            display: "block",
                                        }}
                                    />
                                    <Typography variant="body2" align="center">
                                        {e.toolbox_topic}
                                    </Typography>
                                </Grid>
                            );
                        })}
                </Grid>
                <ToolboxModal
                    toolboxes={this.props.toolboxes}
                    isOpen={this.state.toolboxModal}
                    selectedToolboxes={profile.toolbox_talks}
                    closeModal={() => this.setState({ toolboxModal: false })}
                    updateToolboxList={(val) => {
                        this.props.callback("toolbox_talks", val);
                    }}
                />
            </ComponentTemplate>
        );
    }
}
export default connect(
    (store, props) => {
        const { selectors } = props;
        const { selectToolboxTalks } = selectors;
        return {
            toolboxes: selectToolboxTalks(store),
        };
    },
    { getToolboxTalks }
)(JobPackToolboxTalk);
